import React from 'react';
import styled from 'styled-components';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import Tooltip from '@mui/material/Tooltip';

function GrabButton() {
  return (
    <GrabButtonStyled className="grab-it">
      <Tooltip title="Press and Slide">
        <TouchAppIcon />
      </Tooltip>
    </GrabButtonStyled>
  );
}

const GrabButtonStyled = styled.button`
  align-items: center;
  background-color: #fff;
  padding: 0.5rem;
  font-family: inherit;
  font-size: inherit;
  color: var(--accent-blue);
  border-radius: 50px;
  outline: none;
  border: 2px solid var(--accent-blue);
  cursor: pointer;
  width: 40px;
  height: 40px;
  svg {
    color: var(--accent-blue);

    width: 20px;
    height: 20px;
  }
`;

export default GrabButton;
